import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { SelectAdoProduct } from './SelectAdoProductExtension';

export const SelectAdoProductFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'SelectAdoProduct',
    component: SelectAdoProduct,
  }),
);
